/**
 * JSON string for API `details` field (usage stats / reporting service contract).
 * Keys match backend: ChargeCode, eDEmail, isIAmEDChecked, isAgreementPolicyChecked, isWarRoomChecked
 */
export function buildChargeCodeDetailsJson({
  chargeCodeValue = '',
  eDEmail = '',
  isIAmEDChecked = false,
  isAgreementPolicyChecked = false,
  isWarRoomChecked = false
}) {
  return JSON.stringify({
    ChargeCode: chargeCodeValue || '',
    eDEmail: typeof eDEmail === 'string' ? eDEmail.toLowerCase() : '',
    isIAmEDChecked: !!isIAmEDChecked,
    isAgreementPolicyChecked: !!isAgreementPolicyChecked,
    isWarRoomChecked: !!isWarRoomChecked
  })
}
